import React from 'react';
import PropTypes from 'prop-types';
import ContainerStyled from './styles/PlanEmptyStyled';
import Button from '../../General/Button';

import { ReactComponent as MoneyIcon } from '../../../images/plan-recurrente/money-recurrente.svg';

const PlanEmpty = ({ closePanel }) => {
  return (
    <ContainerStyled>
      <h2>SIN PLANES POR EL MOMENTO</h2>
      <picture>
        <MoneyIcon />
      </picture>
      <p>
        Lo sentimos, de momento no hay planes Recurrentes disponibles, Puedes
        volver a intentarlo más tarde
      </p>
      <Button
        maxWidth="205px"
        color="bubbleGum"
        margin="auto"
        height="48px"
        click={closePanel}
      >
        Volver al inicio
      </Button>
    </ContainerStyled>
  );
};

PlanEmpty.propTypes = {
  closePanel: PropTypes.func.isRequired,
};

export default PlanEmpty;
